import DeliveryPreference from './delivery-preference.container'
import { DELIVERY_OPTION } from './delivery-preference.container'

export { DELIVERY_OPTION }
export default DeliveryPreference
